import { baseApi } from "../baseApi";
export const appointmentApi = baseApi.injectEndpoints({
  tagTypes: ["AppointmentsList"],
  endpoints: (builder) => ({
    getAppointments: builder.query({
      query: (params) => {
        return {
          url: `/patient/appointments.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => response?.response?.data,
      providesTags: ["AppointmentsList"],
    }),

    addAppointments: builder.mutation({
      query: (body) => {
        return {
          url: `/patient/appointments.json`,
          method: "POST",
          body: body,
        };
      },
      transformResponse: (response, meta, arg) => response?.response,
      invalidatesTags: ["AppointmentsList"],
    }),

    getPracticeSpecialities: builder.query({
      query: () => {
        return {
          url: `/practices/patient_portal_practice_specialities.json`,
          method: "GET",
        };
      },
      transformResponse: (response, meta, arg) => response?.response?.data,
    }),
    getPracticeLocations: builder.query({
      query: () => {
        return {
          url: `/practices/patient_portal_locations.json`,
          method: "GET",
        };
      },
      transformResponse: (response, meta, arg) => response?.response?.data,
    }),
    addAppointmentByLocation: builder.mutation({
      query: (body) => {
        return {
          url: `/appointments/add_appointment.json`,
          method: "POST",
          body: body,
        };
      },
      transformResponse: (response, meta, arg) => response?.response,
      invalidatesTags: ["AppointmentsList"],
    }),
    getProviders: builder.query({
      query: (params) => {
        return {
          url: `/providers/index.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => response?.response?.data,
    }),
    getProviderLocations: builder.query({
      query: (params) => {
        return {
          url: `/providers/locations.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => response?.response?.data,
    }),
    getTimeSlots: builder.query({
      query: (params) => {
        return {
          url: `/calendars/get_slots.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => response?.response?.data,
    }),
    getAppointmentSurvey: builder.query({
      query: (params) => {
        return {
          url: `/appointments/get_appointment_survey_questions.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return { ...response?.response?.data, msg: response?.response?.msg };
      },
    }),
    saveAppointmentSurvey: builder.mutation({
      query: (body) => {
        return {
          url: `/appointments/save_appointment_survey.json`,
          method: "POST",
          body: body,
        };
      },
      transformResponse: (response, meta, arg) => response?.response,
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetAppointmentsQuery,
  useGetPracticeSpecialitiesQuery,
  useGetPracticeLocationsQuery,
  useAddAppointmentByLocationMutation,
  useGetProvidersQuery,
  useGetProviderLocationsQuery,
  useGetTimeSlotsQuery,
  useAddAppointmentsMutation,
  useGetAppointmentSurveyQuery,
  useSaveAppointmentSurveyMutation,
} = appointmentApi;
